<div class="PGTicketsEditor">
    <div class="form-group row">
        <div class="col-6">
            <label>
                <b>{{ 'pg-tickets-editor.' + translPrefix + 'price-per-person' | locTranslate}}</b>
            </label>
            <div class="input-group">
                <input class="form-control {{required && value.fullPrice == null ? 'ng-invalid' : ''}}" type="number" step="0.01" min="0" [(ngModel)]="value.fullPrice" (ngModelChange)="onValueChange()" placeholder="{{ 'pg-tickets-editor.' + translPrefix + 'price-not-specified' | locTranslate }}"/>
                <div class="input-group-text"><b>{{getCurrencySymbol()}}</b></div> 
            </div>
        </div>
    </div>

    <div class="mb-2" appPgAnimations="{{value.fullPrice ? 'EnterT' : 'ExitT'}}"> 
        <h5>{{ 'pg-tickets-editor.' + translPrefix + 'other-prices' | locTranslate}}</h5>
        <div class="mb-3">{{ 'pg-tickets-editor.' + translPrefix + 'other-prices-more' | locTranslate}}</div>
        <table class="table">
            <thead>
                <tr>
                    <th>{{ 'pg-tickets-editor.' + translPrefix + 'ticket-name' | locTranslate}}</th>
                    <th>{{ 'pg-tickets-editor.' + translPrefix + 'price' | locTranslate}}</th>
                </tr>
            </thead>
            <tbody>
                @if (value.otherTickets.length == 0) {
                    <tr>
                        <td colspan="3" class="text-muted">{{ 'pg-tickets-editor.' + translPrefix + 'no-other-price' | locTranslate}}</td>
                    </tr>
                }
                @for (item of value.otherTickets; track item) {
                    <tr>
                        <td>
                            <input class="form-control form-control-sm" [ngModel]="getTicketName(item)" (ngModelChange)="setTicketName(item, $event); onValueChange();" placeholder="{{ 'pg-tickets-editor.' + translPrefix + 'ticket-name-placeholder' | locTranslate}}"/>
                        </td>
                        <td>
                            <div class="d-flex">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" type="number" step="0.01" min="0" [(ngModel)]="item.price" (ngModelChange)="onValueChange()"/>
                                    <div class="input-group-text"><b>{{getCurrencySymbol()}}</b></div>
                                </div>
                                <div class="ms-3">
                                    <button class="btn btn-sm btn-danger" (click)="removeTicket(item)">
                                        <i class="fa-regular fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">
                        <button class="btn btn-sm btn-primary float-end" (click)="addTicket()">
                            <span>{{ 'pg-tickets-editor.' + translPrefix + 'add-other-price' | locTranslate}}</span>
                            <i class="fa-regular fa-tag"></i>
                        </button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>